<template>
  <div>
    <StepForMobile
      :currentStep="1"
      :screenType="screenType"
      :title="this.$t('Details')"
    />
    <div v-if="screenType === 'desktop' || uploadStep === 1" :class="screenType !== 'desktop' && 'wrapper-2 pa-2'">
      <DynamicFields
        v-if="session?.interfaceDynamicFields"
        :session="session"
        :lightSessionRestart="() => null"
        :isAuthenticateEmail="isAuthenticateEmail"
        :verifiedEmailsList="verifiedEmails"
        :pushToVerifiedEmailsList="email => verifiedEmails.push(email)"
      />

      <v-checkbox
        v-if="session?.interfaceDynamicFields?.some(el => el.validation === 1)"
        v-model="isSendApprovalEmailLocal"
        hide-details
        class="my-1"
        :label="$t('Send me a confirmation email.')"
        dense
      />
      <div
        v-if="screenType !== 'desktop' && uploadStep === 1"
        class="d-flex justify-end align-center mt-2 mx-2"
        style="height: 42px"
        @click="btnWrapperClicked"
      >
      <div v-if="isShowErrorMessage" class="mx-2">
          <span class="error-message">{{ getErrorMessage() }}</span>
        </div>
        <Button :disabled="getErrorMessage() !== ''" :text="$t('Continue')" :clickAction="continueButtonClicked" />
      </div>
    </div>
  </div>
</template>

<script>
import DynamicFields from '@/components/CommonComponents/DynamicFields/DynamicFields.vue'
import StepForMobile from '@/components/WebsiteInterface/CommonComponents/StepForMobile.vue'
import Button from '@/components/BaseComponents/Button/Button.vue'
import { mapGetters, mapMutations } from 'vuex'
import { getErrorOfDynmicFields } from '@/utils'

export default {
  name: 'DynamicFieldsWrapper',
  data() {
    return {
      isShowErrorMessage: false,
      isSendApprovalEmailLocal: this.isSendApprovalEmail,
      verifiedEmails: [],
    }
  },
  props: {
    session: Object,
    isAuthenticateEmail: Boolean,
    screenType: String,
    isSendApprovalEmail: Boolean,
    setIsSendApprovalEmail: Function,
  },
  components: {
    DynamicFields,
    StepForMobile,
    Button,
  },
  computed: {
    ...mapGetters(['uploadStep']),
    
  },
  watch: {
    isSendApprovalEmailLocal(newVal) {
      this.setIsSendApprovalEmail(newVal);
    },
    isSendApprovalEmail(newVal) {
      this.isSendApprovalEmailLocal = newVal;
    },
    session: {
      handler() {
        this.getErrorMessage()
        this.isShowErrorMessage = false
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations(['SET_UPLOAD_STEP']),
    continueButtonClicked() {
      this.SET_UPLOAD_STEP(2)
    },
    btnWrapperClicked() {
      this.getErrorMessage()
      this.isShowErrorMessage = true
    },
    getErrorMessage() {
        const errorMessage = getErrorOfDynmicFields(this.session.interfaceDynamicFields, this.verifiedEmails)
        if (errorMessage) return errorMessage
      
      return ''
    },
  },
  mounted() {
    
    console.log("session: ", this.session)
  }
}
</script>

<style scoped>
    .error-message {
  color: red;
  font-size: 14px;
  margin-right: auto;
  align-self: center;
}
</style>